import { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";
// import { ProductEngineeringServicesData } from "../../common";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import ContactUsComponent from "../../components/ContactUsComponent/ContactUsComponent";
import FrequentlyAskedQuestions from "../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
// import { getIPGeoLocation } from "../../common/GeneralUtils";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import * as Icons from '../../common/icons/productEngineeringServicesDataIcons';
import Toasts from "../../components/Toasts/Toasts";
// import { useLocation } from "react-router-dom";
// import { Helmet } from "react-helmet";

// import Loadable from "../../components/Loadable"

// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )
// const CustomerReviews = Loadable(
//     lazy(() => import('../../components/CustomerReviews/CustomerReviews'))
// )
// const ContactUsComponent = Loadable(
//     lazy(() => import('../../components/ContactUsComponent/ContactUsComponent'))
// )
// const FrequentlyAskedQuestions = Loadable(
//     lazy(() => import('../../components/FrequentlyAskedQuestions/FrequentlyAskedQuestions'))
// )

const ProductEngineeringServicesScreen = () => {
    // const location = useLocation();
    const [toasts, setToasts] = useState(null)
    const [WebAppDevelopmentData, setData] = useState({});
    const [ProductEngineeringServicesData, setProductEngineeringServicesData] = useState({});
    const [geoLocationData, setGeoLocationData] = useState(null);

    const getAllWebAppDevelopmentData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/webAppDevelopmentData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }
    const getAllProductEngineeringServicesData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/productEngineeringServicesData.json');
            setProductEngineeringServicesData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        // getIPGeoLocation(location.pathname);
        getAllWebAppDevelopmentData();
        getAllProductEngineeringServicesData();
    }, [])

    return (
        <Fragment>
            <Helmet>
                <title>Software Product Engineering Services in India | VarahiSoft</title>
                <meta name="description" content="VarahiSoft offers software product engineering services in India to build scalable, secure and market-ready digital products from idea to launch." />
                <meta name="keywords" content="Software product engineering services" />
                <meta property="og:title" content="Software Product Engineering Services in India | VarahiSoft" />
            </Helmet>
            <div id="main-wrapper">
                <Header geoLocation={setGeoLocationData} />
                <div className="page-wrapper product-engineering-services-page-wrapper">
                    <div className="container-fluid">
                        <div className="page-content-top">
                            <AboutUsBanner bannerImg={ProductEngineeringServicesData?.bannerImg} data={ProductEngineeringServicesData?.headerData} />
                            <div className="content-tech-page-warper">
                                <Container>
                                    <div className="page-context-text">
                                        <h2>{ProductEngineeringServicesData?.elevateExcellence?.title}</h2>
                                    </div>
                                </Container>
                            </div>
                            <section className="elevateExcellence">
                                <Container>
                                    <Row>
                                        <Col lg={6} md={6} sm={6} className="elevate-excellence pe-5 d-flex align-items-center justify-content-center">
                                            <div className="revolutionize-content pe-5">
                                                {ProductEngineeringServicesData?.elevateExcellence?.paragraph?.length > 0 && ProductEngineeringServicesData?.elevateExcellence?.paragraph?.map((text, index) => <p key={index}>{text.text}</p>)}
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6} sm={6}>
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    className="w-100"
                                                    effect="blur"
                                                    src={ProductEngineeringServicesData?.elevateExcellence?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className="GameChanger-process" >
                                <Container>
                                    <h3>{ProductEngineeringServicesData?.GameChanger?.title}</h3>
                                    <h4 className="pe-5">{ProductEngineeringServicesData?.GameChanger?.subTitle}</h4>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            {/* <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        src={ProductEngineeringServicesData?.GameChanger?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col> */}
                                            {ProductEngineeringServicesData?.GameChanger?.listData?.map((chooseData, index) => {
                                                const Icon = Icons[chooseData?.icon] || null;
                                                return (
                                                    <Col key={index} className="content-body" lg={6} md={6} xs={12}>
                                                        <div className="why-main-div d-flex align-items-center justify-content-start  mb-4">
                                                            <div className="chooseIcon">{Icon && <Icon />}</div>
                                                            <div className="why-cho0se-body">
                                                                <h5>{chooseData?.title}</h5>
                                                                {chooseData?.text && <p className="m-0">{chooseData?.text}</p>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                )
                                            })}
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className='poc-service'>
                                <Container className='page-warper'>
                                    <h3 className="m-0">{ProductEngineeringServicesData?.pocBox?.title}</h3>
                                    <p className="m-0">{ProductEngineeringServicesData?.pocBox?.subtitle}</p>
                                </Container>
                            </section>
                            <section className="core-mobile-app-section-warper">
                                <Container>
                                    <h3>{ProductEngineeringServicesData?.breakthroughResultsData?.title}</h3>
                                    <h4>{ProductEngineeringServicesData?.breakthroughResultsData?.subTitle}</h4>
                                    <div className="core-mobile-app-card">
                                        <Row className="m-0">
                                            {ProductEngineeringServicesData?.breakthroughResultsData?.listData?.map((cardItem, index) => {
                                                const CardIcon = Icons[cardItem?.icon] || null;
                                                return <Col key={index} lg={4} md={4} sm={6} xs={12}>
                                                    <Card className="app-card">
                                                        <CardBody>
                                                            {cardItem?.icon && <p>
                                                                {CardIcon && <CardIcon />}
                                                            </p>}
                                                            {cardItem?.number && <p className="number0q">
                                                                {cardItem?.number}
                                                            </p>}
                                                            <h5 className="card-title-div">{cardItem?.title}</h5>
                                                            <p><span>{cardItem?.text}</span>{cardItem?.bold && <span>{cardItem?.bold}</span>}{cardItem?.text1 && <span>{cardItem?.text1}</span>}</p>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            })}
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className="core-mobile-app-process" >
                                <Container>
                                    <h3>{ProductEngineeringServicesData?.WhyChooseVarahiSoftforECommerceDevelopment?.title}</h3>
                                    <h4 className="pe-5">{ProductEngineeringServicesData?.WhyChooseVarahiSoftforECommerceDevelopment?.subTitle}</h4>
                                    <div className="core-mobile-app-card pt-5">
                                        <Row>
                                            <Col lg={6} md={6} xs={12} className="d-flex align-items-center">
                                                <div className="img-div-width">
                                                    <LazyLoadImage
                                                        alt={'image'}
                                                        className="w-100"
                                                        effect="blur"
                                                        src={ProductEngineeringServicesData?.WhyChooseVarahiSoftforECommerceDevelopment?.pageImg} // use normal <img> attributes as props
                                                    />
                                                </div>
                                            </Col>
                                            <Col className="content-body" lg={6} md={6} xs={12}>
                                                {ProductEngineeringServicesData?.WhyChooseVarahiSoftforECommerceDevelopment?.listData?.map((chooseData, index) => {
                                                    const WhyIcon = Icons[chooseData?.icon] || null;
                                                    return (
                                                        <div key={index} className="px-5 d-flex align-items-start justify-content-start gap-3">
                                                            <div className="why-choose-icon">{WhyIcon && <WhyIcon />}</div>
                                                            <div className="why-cho0se-body">
                                                                <h5>
                                                                    {chooseData?.title}
                                                                </h5>
                                                                <p>{chooseData?.text}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    </div>
                                </Container>
                            </section>
                            <section className="who-we-serve-section">
                                <Container>
                                    <div className="who-we-serve-header">
                                        <h3 className="m-0">{ProductEngineeringServicesData?.WhoWeServe?.title}</h3>
                                        <p className="m-0">{ProductEngineeringServicesData?.WhoWeServe?.text}</p>
                                    </div>
                                    <Row>
                                        <Col className="custom-col" lg={3} md={3} >
                                            {ProductEngineeringServicesData?.WhoWeServe?.listLeft?.map((leftData, index) => {
                                                return (
                                                    <Card key={index} className="assurance-warper-card">
                                                        <CardHeader>{leftData?.title}</CardHeader>
                                                        <CardBody>{leftData?.text}</CardBody>
                                                    </Card>
                                                )
                                            })}
                                        </Col>
                                        <Col lg={6} md={6} >
                                            <div className="img-div-width">
                                                <LazyLoadImage
                                                    alt={'image'}
                                                    effect="blur"
                                                    className="w-100"
                                                    src={ProductEngineeringServicesData?.WhoWeServe?.pageImg} // use normal <img> attributes as props
                                                />
                                            </div>
                                        </Col>
                                        <Col lg={3} md={3} className="custom-col" >
                                            {ProductEngineeringServicesData?.WhoWeServe?.listRight?.map((rightData, index) => {
                                                return (
                                                    <Card key={index} className="assurance-warper-card">
                                                        <CardHeader>{rightData?.title}</CardHeader>
                                                        <CardBody>{rightData?.text}</CardBody>
                                                    </Card>
                                                )
                                            })}
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                            <section className='Tech-Industry-Quality'>
                                <div className='tech-content' style={{ backgroundImage: `url(${ProductEngineeringServicesData?.TurningIdeas?.bgImg})` }}>
                                    <div className="bg-color-rgba">
                                        <Container className="ps-5">
                                            <Row className="justify-content-end">
                                                <Col lg="7" md="7" className="align-self-start">
                                                    <div className='page-content'>
                                                        <h3>{ProductEngineeringServicesData?.TurningIdeas?.title}</h3>
                                                        {ProductEngineeringServicesData?.TurningIdeas?.paragraph?.map((para, index) => {
                                                            return (
                                                                <p key={index}>{para?.text}</p>
                                                            )
                                                        })}
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </section>
                            <CustomerReviews />
                            <div className="home-contact-page">
                                <ContactUsComponent setToasts={setToasts} GeoIpData={geoLocationData} />
                            </div>
                            <FrequentlyAskedQuestions faqData={WebAppDevelopmentData?.FrequentlyAskedQuestionsData} />
                        </div>
                    </div>
                </div>
                <Footer />
                {toasts && <Toasts toastsList={toasts} />}
            </div>
        </Fragment>
    );
}

ProductEngineeringServicesScreen.propTypes = {
    classes: PropTypes.object
};

export default ProductEngineeringServicesScreen;
